! function(s) {
    var e = setInterval(function() {
        "complete" === document.readyState && (clearInterval(e), console.log(document.readyState), setTimeout(function() {
            s(".progress").fadeOut(500), AOS.init({
                once: !0
            })
        }, 500))
    }, 100);
    s(".main-nav li").hover(function() {
        var e = s(this).index();
        s(".site-navigation .colmn-img li").eq(e).toggleClass("active")
    }), s("header .toggle-btn").click(function() {
        s(this).toggleClass("active"), s(".site-navigation").toggleClass("active"), s("body").toggleClass("active-nav"), s("header").toggleClass("active-nav")
    }), s(".place-slider").slick({
        dots: !0,
        responsive: [{
            breakpoint: 992,
            settings: {
                arrows: !1
            }
        }]
    }), s(".catering-slider").slick({
        dots: !0,
        responsive: [{
            breakpoint: 992,
            settings: {
                arrows: !1
            }
        }, {
            breakpoint: 768,
            settings: "unslick"
        }]
    }), 
      
      /* s(".suggest-slider").slick({
        dots: !0,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: !0,
        arrows: !1,
        mobileFirst: !0,
        responsive: [{
            breakpoint: 767,
            settings: "slick"
        }]
    }), */ s(".category-slider").slick({
        dots: !1,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: !0,
        centerPadding: "200px",
        responsive: [{
            breakpoint: 1600,
            settings: {
                centerPadding: "170px"
            }
        }, {
            breakpoint: 1400,
            settings: {
                centerPadding: "100px"
            }
        }, {
            breakpoint: 1200,
            settings: {
                centerPadding: "50px",
                slidesToShow: 3
            }
        }, {
            breakpoint: 992,
            settings: {
                centerPadding: "50px",
                slidesToShow: 3
            }
        }, {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                centerPadding: "100px"
            }
        }, {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                centerPadding: "100px"
            }
        }, {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                centerPadding: "50px"
            }
        }]
    }), s(".popup-inner-slider").slick({
        arrows: !1,
        dots: !0,
        infinite: !1
    }), s(".popup-group").slick({
        infinite: !1,
        swipe: !1,
        fade: !0,
        prevArrow: s(".popup-nav li:first"),
        nextArrow: s(".popup-nav li:last")
    }), s(".product-slider").slick({
        arrows: !1,
        dots: !0
    });
    var i = s(".collaboration-section ul li").length,
        t = s(".collaboration-section ul li").width();
    s(".collaboration-section ul").css("width", i * t), s(window).scroll(function() {
        0 < s(this).scrollTop() ? s("header").addClass("fixed") : s("header").removeClass("fixed")
    }), s(".faq-box .colmn-box .btn-box").click(function() {
        s(this).siblings().slideToggle(), s(this).parent().siblings().children(".result-box").slideUp()
    }), s(".sleeves-section .colmn-box ,.events-section .colmn-img").click(function(e) {
        e.stopPropagation();
        var i = s(this).attr("data-popup");
        s(".popup").addClass("active");
        var t = s("#" + i).index();
        s(".popup-group").slick("slickGoTo", t)
    }), s(".popup .popup-container").click(function(e) {
        e.stopPropagation()
    }), s(".popup .close").click(function() {
        s(".popup").removeClass("active")
    }), s("body").click(function() {
        s(".popup").removeClass("active")
    }), s(".video-box .play-btn").click(function(e) {
        e.stopPropagation(), s(".popup").addClass("active"), setTimeout(function(){
          document.getElementById("videoPopup").play();
        }, 3000);
    }), s(".right-content .content-wrapper").eq(0).show(), s(".left-sidebar ul li:not(:last-child) a").click(function(e) {
        e.preventDefault();
        var i = s(this).attr("href");
        if (s(this).hasClass("active")) {
            var t = s(this).closest("div.container .left-sidebar").attr("data-show");
            "orderHistory" == t && (s(".order-history").fadeIn(900), s(".order-details").fadeOut(300)), "billingInform" == t && (s(".bill-info").fadeIn(900), s(".card-info").fadeOut(300))
        }
        s(i).fadeIn(900).siblings().hide(), s(".left-sidebar ul li a").removeClass("active"), s(".left-sidebar").attr("data-show", ""), s(this).addClass("active"), s(".left-sidebar").attr("data-show", i.split("#")[1]);
      
    }), s(".left-sidebar select").change(function(e) {
        e.preventDefault();
        var i = s(this).find("option:selected").val();
        if (s(this).hasClass("active")) {
            var t = s(this).closest("div.container .left-sidebar").attr("data-show");
            "orderHistory" == t && (s(".order-history").fadeIn(900), s(".order-details").fadeOut(300)), "billingInform" == t && (s(".bill-info").fadeIn(900), s(".card-info").fadeOut(300))
        }
        s(i).fadeIn(900).siblings().hide(), s(".left-sidebar ul li a").removeClass("active"), s(".left-sidebar").attr("data-show", ""), s(this).addClass("active"), s(".left-sidebar").attr("data-show", i.split("#")[1])
    }),s("header .store-btn").click(function() {
        if(s("#PageContainer > .popup-wrapper").length){
          s(".popup-wrapper").addClass("active"), s("body").addClass("active-cart"),s(window).scrollTop(0);
        }
    }), s("body").on("click",".closeBtn",function() {
        s(".popup-wrapper").removeClass("active"), s("body").removeClass("active-cart")
    }), 
      s(".order-history .delivery-table tr").not(":first").click(function(e) {
        
        e.preventDefault(), s(".common_ord").removeClass("show_ord"),s(".order-history").fadeOut(300), s(".order-details").fadeIn(900),s("."+s(this).data("target")).addClass('show_ord')
    }), 
      s("#cardUpdate").click(function() {
        s(".bill-info").fadeOut(300), s(".card-info").fadeIn(900)
    }), s(".location-page .accordion-section .colmn-head").click(function(e) {
      	e.preventDefault();
        s(this).siblings().slideToggle(), s(this).parent().siblings().children(".colmn-body").slideUp();
      	s(window).scrollTop(0);
    }), s(window).scroll(function() {
        var e = 2 * s(this).scrollTop();
        s(".icon-group span").css("transform", "rotate(" + e + "deg)")
    });
    s.ajax({
        async: !0,
        crossDomain: !0,
        url: "https://community-open-weather-map.p.rapidapi.com/weather?callback=test&id=2172797&units=metric&mode=xml%2C%20html&q=Los%20Angeles",
        method: "GET",
        headers: {
            "x-rapidapi-host": "community-open-weather-map.p.rapidapi.com",
            "x-rapidapi-key": "f5b7c76f7amsh9399b6e6afc2ae0p1d1871jsn2c537dbb4172"
        }
    }).done(function(e) {
        var i = e.split("test(");
        i = i[1].substring(0, i[1].length - 1), new_res = JSON.parse(i), console.log(new_res), console.log(e)
    });
  jQuery.getJSON('/cart.js', function(cart) {
             if( cart.item_count == 0 ){
              s(".cart-number").css("display","none");
             }
  });
  $('#prod_btn').click(function(){
       $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: $('#prod_form')
              .serialize(),
         success: function(){
         s(".popup-wrapper").addClass("active");
           s("body").addClass("active-cart");
           s(window).scrollTop(0);
           s("#PageContainer > .popup-wrapper").load(location.href + " .popup-main");
           s(".cart-number").load(location.href + " .cart-number span");
            jQuery.getJSON('/cart.js', function(cart) {
             if( cart.item_count == 0 ){
              s(".cart-number").css("display","none");
             }
             else{
               s(".cart-number").css("display","flex");
             }
           });
         },
         error: function(e){
           console.log(e);
         }
        });
  });
  $("body").on("change",".cart__qty-input",function(){
      $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          dataType: 'json',
          data: $(this).parents("form")
              .serialize(),
         success: function(){
           if(s("#PageContainer > .popup-wrapper").length){
             s("#PageContainer > .popup-wrapper").load(location.href + " .popup-main");
           }
           if(s("#shopify-section-cart-template-altr").length){
             s("#shopify-section-cart-template-altr").load(location.href + " .cart_wrapper");
           }
           s(".cart-number").load(location.href + " .cart-number span");
            jQuery.getJSON('/cart.js', function(cart) {
             if( cart.item_count == 0 ){
              s(".cart-number").css("display","none");
             }
             else{
               s(".cart-number").css("display","flex");
             }
           });
         },
         error: function(e){
           console.log(e);
         }
        });
  });
  $("body").on("click","a[data-line]",function(){
    var linenumber = $(this).attr("data-line");
       $.ajax({
         type: 'POST',
          url: '/cart/change.js',
          data: 'quantity=0&line=' + linenumber,
          dataType: 'json',
          success: function(){
           if(s("#PageContainer > .popup-wrapper").length){
             s("#PageContainer > .popup-wrapper").load(location.href + " .popup-main");
           }
           if(s("#shopify-section-cart-template-altr").length){
             s("#shopify-section-cart-template-altr").load(location.href + " .cart_wrapper");
           }
           jQuery.getJSON('/cart.js', function(cart) {
             if( cart.item_count == 0 ){
              s(".cart-number").css("display","none");
             }
             else{
               s(".cart-number").css("display","flex");
             }
           });
           s(".cart-number").load(location.href + " .cart-number span");
         },
         error: function(e){
           console.log(e);
         }
        });
  });
  $(document).ready(function(){
    $("body").on("click",".filter-nav li",function(event){
      $(".filter-nav").css("pointer-events","none");
//       $(".loader_image").fadeIn(300);
       $(this).parent().find(".active").removeClass("active");
      $(this).addClass("active");
      event.preventDefault();
     
      var ajax_url = $(this).find("a").data("href");
      if(history.pushState) {
        history.pushState({url:ajax_url}, ajax_url, ajax_url);
      }
      $(".product-listing-outer").load(" .product-listing");
      setTimeout(function(){
       $(".filter-nav").css("pointer-events","all");
//        $(".loader_image").css("display","none");
      },300);
      return false;
    });

   $("body").on("change",".mobile-filter select",function(event){
      $(".mobile-filter").css("pointer-events","none");
//       $(".loader_image").fadeIn(300);

      event.preventDefault();
     
      var ajax_url = $(this).val();
      if(history.pushState) {
        history.pushState({url:ajax_url}, ajax_url, ajax_url);
      }
      $(".product-listing-outer").load(" .product-listing");
      setTimeout(function(){
       $(".mobile-filter").css("pointer-events","all");
//        $(".loader_image").css("display","none");
      },2000);
      return false;
    });
  });

  $(window).on("popstate", function(e) {
     $(".product-listing-outer").load(" .product-listing");
  });
//           (function(original) {
//               history.pushState = function(state) {
//                   $(".template-collection").load(window.location.href+ "/#Collection");
//                   return original.apply(this, arguments);
//               };
//           })(history.pushState);
  $('.site-navigation .main-nav li:last a').addClass('btn custom-btn');
  retinajs();
  
  if($(window).width() < 767){
  	$('.site-navigation .colmn-box').scroll(function() {    
        var scroll = $('.site-navigation .colmn-box').scrollTop();
        if (scroll >= 10) {

            $("header.active-nav").addClass("darkHeader");
        }else{
          $("header.active-nav").removeClass("darkHeader");
        }
    }); 
  }
 
  

}(jQuery);


$(document).ready(function(){
  setTimeout(function(){
    $('.lazy-load-img').each(function(){
      $(this).html('<img src="'+$(this).attr('load-img')+'"  />');
    });},5000);
   
    if(screen.width<768){
        $('.suggest-slider').slick({
          dots: !0,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: !0,
          arrows: !1,
        });
    }
  $('body').on('change','select[name="id"]',function(){
   var price =  $(this).find('option[value="'+$(this).val()+'"]').attr("data-pice");
   $(".product_price_original").text(price);
  });
});

$(window).resize(function(){
	if(screen.width<768){
        $('.suggest-slider').slick({
          dots: !0,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: !0,
          arrows: !1,
        });
    }
});